import { useEffect } from "react";

import { triggerCustomerIoShopSummaryPageViewed } from "@/features/analytics/triggers";
import type { Product } from "@/features/products/models";

interface UseMarkShopSummaryVisitedParams {
  product?: Product;
}

export const useMarkShopSummaryVisited = ({
  product,
}: UseMarkShopSummaryVisitedParams) => {
  useEffect(() => {
    if (product) {
      triggerCustomerIoShopSummaryPageViewed({ product });
    }
  }, [product]);
};
